export const ACTION_MESSAGE = 'ACTION_MESSAGE'
// TODO: remove loading
export const LOADING = 'LOADING'
export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'
export const WARNING = 'WARNING'



// WEBPACK FOOTER //
// ./src/utils/feedbackTypes.js